// Primitive tokens for spacing and border radius

export const spacing = {
  xxs: 0.25, // 4px
  xs: 0.5, // 8px
  sm: 0.75, // 12px
  md: 1, // 16px
  lg: 1.5, // 24px
  xl: 2, // 32px
  xxl: 3, // 48px
} as const;

// semantic tokens
export const borderRadius = {
  subtle: spacing.xs,
  strong: spacing.sm,
  full: "50%",
} as const;

export type Spacing = typeof spacing;
export type BorderRadius = typeof borderRadius;
